module.exports = __webpack_public_path__ + "static/img/82.8db87f3.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/img_left_icon/82.png
// module id = rlwI
// module chunks = 1